import { BaseViewStore} from 'core/stores';
import { action, observable } from "mobx";

class PatientNewFlowDeleteInsurancePolicyConfirmModalStore extends BaseViewStore {
    @observable accessor isDeleting = false;
    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
    }

    @action.bound
    async onConfirm() {
        try {
            this.isDeleting = true;
            await this.modalParams.data.deleteInsurancePolicy();
            this.isDeleting = false;
            this.modalParams.close();
        }
        catch (err) {
            return this.onUpdateError(err);
        }
    }
}

export default PatientNewFlowDeleteInsurancePolicyConfirmModalStore;
